<template>
  <div class="home-listing">

    <!-- Loading Animation START 
    [[ This is the loading animation that is activated while the work orders are loading, either by the initial load or after refreshing the work order list. This shows when (loadingWorkOrders == true) ]] -->
    <transition name="fade">
      <div v-show="loadingWorkOrders" class="full-box">
        <div class="loadingWorkOrders">
          <div class="logo"></div>
          <div class="loading-image"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw mcText"></i></div>
          Loading Work Orders         
        </div>
      </div> 
    </transition> 
    <!-- Loading Animation END -->   
    
    <!-- Mobile Bottom Bar START 
    [[ Its the bottom bar that is only visible on mobile view, that holds the currently picked Sort Option and Search buttons. It's all the way up in the code so its loaded quickly, but it gets absolutely positioned by CSS rules. ]] -->
    <div class="mobileBottomBar">
      <div class="container">
        <div class="row">
          <div class="col-xs-6" v-on:click="openMobileSort()">
            Sort By
            <span class="mcText">{{pickedMobileSort}}</span>
          </div>
          <div class="col-xs-6 searchDiv" v-on:click="openMobileSearch()">
            <i class="fa fa-search mcText" aria-hidden="true"></i> Search
          </div>
        </div>
      </div>
    </div>
    <!-- Mobile Bottom Bar END -->

    <!-- Mobile Menu START 
    [[ Mobile menu that comes out from the side, when you click on the menu button in the header. This shows when (openMenu == true) ]] -->
    <template v-if="openMenu">
      <div class="overlay">
        <div class="mobile-menu">
          <div class="inner">
            <div v-on:click="hideMenu()" class="close-menu"><i class="fa fa-times" aria-hidden="true"></i></div>
            <h2 class="mcText">{{username}}</h2>
            <ul>
              <li v-on:click="refreshListing()">My Work Orders <i class="fa fa-list-ul" aria-hidden="true"></i></li>
              <li v-on:click="logout()">Log Out <i class="fa fa-sign-out" aria-hidden="true"></i></li>
            </ul><br><br>
          </div>
        </div>
      </div> 
    </template>
    <!-- Mobile Menu END -->

    <!-- Mobile Sorting Options START
    [[ Sorting options for mobile. This popup shows when (mobileSortOpen == true) which is currently triggered by a button on the Mobile Bottom Bar with the openMobileSort() function. These functions are predefined in the JS in the code below in this component. ]] -->
    <template v-if="mobileSortOpen">
      <div class="overlay">
        <div class="mobile-sort">
          <div class="inner">
             <h3>Sort By</h3>
              <p><a href="#" v-bind:class="{ mcBGactive: sortOption01 }" v-on:click="sortDateNewest()">Date | Newest</a></p>
              <p><a href="#" v-bind:class="{ mcBGactive: sortOption02 }" v-on:click="sortDateOldest()">Date | Oldest</a></p>
              <p><a href="#" v-bind:class="{ mcBGactive: sortOption03 }" v-on:click="sortDistrict()">District</a></p> 
              <p><a href="#" v-bind:class="{ mcBGactive: sortOption04 }" v-on:click="sortAddress()">Street</a></p> 
              <p><a href="#" v-bind:class="{ mcBGactive: sortOption05 }" v-on:click="sortProblem()">Problem</a></p>
          </div>
        </div>
      </div> 
    </template>
    <!-- Mobile Sorting Options END -->

    <!-- Mobile Search START
    [[ Sorting options for mobile. This popup shows when (mobileSortOpen == true) which is currently triggered by a button on the Mobile Bottom Bar with the openMobileSort() function. These functions are predefined in the JS in the code below in this component. ]] -->
    <template v-if="mobileSearchOpen">
      <div class="overlay">
        <div class="mobile-search">
          <div class="inner">
             <h3>Search</h3>
              <input @keyup.enter="search()" v-model="searchWO" type="text" class="form-control"> <a v-on:click="search()" class="btn mcBG" href="#"><i class="fa fa-search" aria-hidden="true"></i> Search</a>
          </div>
        </div>
      </div> 
    </template>
    <!-- Mobile Search STOP -->

    <div class="main-header">
      <div class="top">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">

            <!-- Tablet Header START 
            [[ Includes the ability to update the listings ]] -->
            <div v-if="$mq.resize && $mq.above($mv.tablet)">
              <button v-on:click="refreshListing()" class="pull-right btn header-btn mcBG scBGHover"><i class="fa fa-refresh" aria-hidden="true"></i> Update Listings</button>
            </div>
            <!-- Tablet Header END -->

            <!-- Mobile Header START 
            [[ Includes the ability to update the listings & to show the mobile menu defined up above in the code. ]] -->
            <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
              <ul>
                <li v-on:click="refreshListing()"><i class="fa fa-refresh" aria-hidden="true"></i></li>
                <li v-on:click="showMenu()"><i class="fa fa-bars" aria-hidden="true"></i></li>
              </ul>
            </div>
            <!-- Mobile Header END -->

            <div class="logo"></div>

            </div>
          </div>
        </div>
      </div>
      <!-- Main Header END -->

      <!-- Header Bar START -->
      <div class="inner-header-bar mcBG">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">
              <img src="static/img/i3v_icon_white.png" class="pull-right">
              <h1>My Work Orders <span class="scText">[{{ workOrders.length }}]</span></h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Header Bar END -->

    <!-- Main Tablet View START 
    [[ Everything starting from now is what's seen in desktop/tablet mode. The exact pixel value is defined in the "main.js" file, at the moment of this comment, it was 768px. If the viewport is less than 768px, which are small tablets and mobile phones, then they cannot see the following. ]] -->
    <div v-if="$mq.resize && $mq.above($mv.tablet)" class="tablet-view">
      <div class="container">
        <div class="row tabletSortSearchRow">

          <!-- Sort Options START 
          [[ These call on predefined functions for sorting the work order list. These functions are defined in the JS code at the bottom of this component file. They also bind an "active" click on click. ]] -->
          <div class="col-sm-6">
            Sort By: <a href="#" class="scText" v-bind:class="{ mcBGactive: sortOption01 }" v-on:click="sortDateNewest()">Date | Newest</a> <a href="#" class="scText" v-bind:class="{ mcBGactive: sortOption02 }" v-on:click="sortDateOldest()">Date | Oldest</a> <a href="#" class="scText" v-bind:class="{ mcBGactive: sortOption03 }" v-on:click="sortDistrict()">District</a> <a href="#" class="scText" v-bind:class="{ mcBGactive: sortOption04 }" v-on:click="sortAddress()">Street</a> <a href="#" class="scText"  v-bind:class="{ mcBGactive: sortOption05 }" v-on:click="sortProblem()">Problem</a>
          </div>
          <!-- Sort Options END -->

          <!-- Search START 
          [[ Whatever gets entered in the search input, gets passed through a search() function described below. It searches both completed and open work orders ]] -->
          <div class="col-sm-6">
            Search: <input @keyup.enter="search()" v-model="searchWO" type="text" class="form-control"> <a v-on:click="search()" class="btn mcBG scBGHover" href="#"><i class="fa fa-search" aria-hidden="true"></i></a>
          </div>
        </div>

        <div class="row flexrow">

          <!-- Left Column START 
          [[ This is where we show the Open Work Orders ]] -->
          <div class="col-sm-5">
            <div class="inner">
              <h2>Open Work Orders</h2>
               <div id="woListing">
                 <ul> 
                  <li v-for="workOrder in orderBy(filterBy(workOrders, searchTerm, 'woNumber', 'situsLabel', 'problemDescription'), orderTerm, orderDesc)" v-if="!workOrder.fieldComplete && !workOrder.isVoided" v-bind:class="'completed' + workOrder.fieldComplete + ' priority' + workOrder.priority" v-on:click="woSelection(workOrder.woNumber)">
                  <div class="container-fluid"> 
                    <div class="row">
                      <div clworkOrder.priorityass="col-xs-12">
                        <div class="woTopRow">
                          <strong>WO#:</strong> {{workOrder.woNumber}} | <strong>Date:</strong> {{workOrder.scheduledDate | moment("MMM Do, YYYY") }}
                        </div>
                        <div><strong>District Name:</strong> {{workOrder.districtName}}</div>
                        <div><strong>Address:</strong> {{workOrder.situsNum}} {{workOrder.situsLabel}}</div>
                        <div><strong>City:</strong> {{workOrder.city}}</div>
                        <div><strong>Problem:</strong> {{workOrder.problemDescription}}</div>
                      </div>
                    </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Left Column END --> 

          <!-- Center Column START 
          [[ This is where we show the Closed Work Orders ]] -->
          <div class="col-sm-4">
            <div class="inner">
              <h2>Closed Work Orders</h2>
              <div id="woListing">
                <ul> 
                  <li v-for="workOrder in orderBy(filterBy(workOrders, searchTerm, 'woNumber', 'situsLabel', 'problemDescription'), orderTerm, orderDesc)" v-if="workOrder.fieldComplete && !workOrder.isVoided" v-bind:class="'completed' + workOrder.fieldComplete" v-on:click="woSelection(workOrder.woNumber)">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-xs-12">
                        <div class="woTopRow">
                          <strong>WO#:</strong> {{workOrder.woNumber}} | <strong>Date:</strong> {{workOrder.scheduledDate | moment("MMM Do, YYYY") }}
                        </div>
                        <div><strong>Problem:</strong> {{workOrder.problemDescription}}</div>
                      </div>
                    </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Center Column END --> 

          <!-- Right Column START 
          [[ This is where we show the Menu ]] -->
          <div class="col-sm-3">
            <div class="inner-dark">
              <h3 class="mcText"><span>Username</span>
              {{username}}</h3>
              <ul>
                <li v-on:click="refreshListing()">My Work Orders <i class="fa fa-list-ul" aria-hidden="true"></i></li>
                <li v-on:click="logout()">Log Out <i class="fa fa-sign-out" aria-hidden="true"></i></li>
              </ul><br><br>
            </div>
          </div>
          <!-- Right Column END -->

        </div>
      </div>
    </div> 
    <!-- Main Tablet View END -->

    <!-- Main Mobile View START 
    [[ Everything starting from now is what's seen in mobile mode. The exact pixel value is defined in the "main.js" file, at the moment of this comment, it was 768px. If the viewport is more than 768px, which are small tablets and mobile phones, then they cannot see the following. ]] -->
    <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
      <div class="mobile-view">
        <div id="woListing">
          <ul> 

              <!-- Open Work Orders START 
              [[ We first load all the work orders that are open. Regardless of the sort / search, open work orders will always load first and have their respective styles depending on their priority. ]]  -->
              <li v-for="workOrder in orderBy(filterBy(workOrders, searchTerm, 'woNumber', 'situsLabel', 'problemDescription'), orderTerm, orderDesc)" v-if="!workOrder.fieldComplete && !workOrder.isVoided" v-bind:class="'completed' + workOrder.fieldComplete + ' priority' + workOrder.priority" v-on:click="woSelection(workOrder.woNumber)">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="woTopRow">
                        <strong>WO#:</strong> {{workOrder.woNumber}} | <strong>Date:</strong> {{workOrder.scheduledDate | moment("MMM Do, YYYY") }}
                      </div>
                      <div><strong>District Name:</strong> {{workOrder.districtName}}</div>
                      <div><strong>Address:</strong> {{workOrder.situsNum}} {{workOrder.situsLabel}}</div>
                      <div><strong>City:</strong> {{workOrder.city}}</div>
                      <div><strong>Problem:</strong> {{workOrder.problemDescription}}</div>
                    </div>
                  </div>
                </div>
              </li>
              <!-- Open Work Orders END --> 

              <!-- Closed Work Orders START 
              [[ Then we load all the closed work orders. They also have a special styling and are always at the end of the same listing.  ]]  -->
              <li v-for="workOrder in orderBy(filterBy(workOrders, searchTerm, 'woNumber', 'situsLabel', 'problemDescription'), orderTerm, orderDesc)" v-if="workOrder.fieldComplete && !workOrder.isVoided" v-bind:class="'completed' + workOrder.fieldComplete" v-on:click="woSelection(workOrder.woNumber)">         
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-xs-10">
                      <div class="woTopRow">
                        <strong>WO#:</strong> {{workOrder.woNumber}} | <strong>Date:</strong> {{workOrder.scheduledDate | moment("MMM Do, YYYY") }}
                      </div>
                      <div><strong>District Name:</strong> {{workOrder.districtName}}</div>
                      <div><strong>Address:</strong> {{workOrder.situsNum}} {{workOrder.situsLabel}}</div>
                      <div><strong>City:</strong> {{workOrder.city}}</div>
                      <div><strong>Problem:</strong> {{workOrder.problemDescription}}</div>
                    </div>
                  </div>
                </div>
              </li>
               <!-- Closed Work Orders END --> 

            </ul>
          </div>
        </div>
      </div>
      <!-- Main Mobile View END --> 


  <div class="container">
   <pre v-show="false">
      {{ $data.workOrders }}
    </pre>
  </div>


  </div>
  


</template>

<script>
import Store from '../store'
import User from '../services/user'
import { getWorkOrders } from '../services/requests'
import { BasicSelect } from 'vue-search-select'

export default {
  name: 'home',
  created() {

    if(!User.isAuthenticated()) {
      this.$router.replace('/login')
    }

    this.username = User.getUsername()

  Store.whenEmployeesReady((employees) => {
      this.employees = Store.employees
      
      let cleanUser = this.username.trim().toLowerCase()
      let foundUser = false

       this.employees.forEach((employee) => {
        if (employee.sodaUserName.toLowerCase() === cleanUser) {
          this.savedEmployeeCode = employee.employeeCode

           foundUser = true
        }
      })
  
    localStorage.setItem('currentUserCode', this.savedEmployeeCode);
   })    
     

    getWorkOrders()
      .toArray((woList) => {
          this.loadingWorkOrders = false,

          woList.forEach((record) => {
              var recordAddress = record.situsLabel 
              var recordDistrict = record.districtName
              record.Details = ''
              record.Details = recordDistrict + ' ' + recordAddress
          
        })


        this.workOrders = woList
      }
    )
  },
  components: {
    BasicSelect
  },
  methods: {
 
    woSelection (id) {
      this.$router.push('/workorder/' + id)
    },
    showMenu() {
      this.openMenu = true;
    },
    hideMenu() {
      this.openMenu = false;
    },
    logout() {
      User.logout()
      this.$router.replace('/login')
      alert('You have succesfully logged out!')
    },
    refreshListing() {
      this.loadingWorkOrders = true;
      this.openMenu = false;
      this.searchTerm = "";
      this.workOrders.splice(0,this.workOrders.length)
      getWorkOrders().toArray((woList) => {
        this.loadingWorkOrders = false,
        this.workOrders = woList
      })
    },
    sortDateOldest() {
        this.orderTerm = 'scheduledDate';
        this.orderDesc = 1;
        this.sortOption01 = false;
        this.sortOption02 = true;
        this.sortOption03 = false;
        this.sortOption04 = false;
        this.sortOption05 = false;
        this.mobileSortOpen = false;
        this.pickedMobileSort = "Date | Oldest";
    },
    sortDateNewest() {
        this.orderTerm = 'scheduledDate';
        this.orderDesc = -1;
        this.sortOption01 = true;
        this.sortOption02 = false;
        this.sortOption03 = false;
        this.sortOption04 = false;
        this.sortOption05 = false;
        this.mobileSortOpen = false;
        this.pickedMobileSort = "Date | Newest";
    },
    sortDistrict() {
        this.orderTerm = 'districtName';
        this.orderDesc = 1;
        this.sortOption01 = false;
        this.sortOption02 = false;
        this.sortOption03 = true;
        this.sortOption04 = false;
        this.sortOption05 = false;
        this.mobileSortOpen = false;
        this.pickedMobileSort = "District";
    },
    sortAddress() {
        this.orderTerm = 'Details';
        this.orderDesc = 1
        this.sortOption01 = false;
        this.sortOption02 = false;
        this.sortOption03 = false;
        this.sortOption04 = true;
        this.sortOption05 = false;
        this.mobileSortOpen = false;
        this.pickedMobileSort = "Street";
    },
    sortProblem() {
        this.orderTerm = 'problemDescription';
        this.orderDesc = 1
        this.sortOption01 = false;
        this.sortOption02 = false;
        this.sortOption03 = false;
        this.sortOption04 = false;
        this.sortOption05 = true;
        this.mobileSortOpen = false;
        this.pickedMobileSort = "Problem";
    },
    search() {
      this.searchTerm = this.searchWO;
      this.mobileSearchOpen = false;
    },
    openMobileSort() {
      this.mobileSortOpen = true;
      window.scrollTo(0,0);
    },
    openMobileSearch() {
      this.mobileSearchOpen = true;
    },
  },
  data () {
    
    return {
      savedEmployeeCode: '',
      employees: [],
      openMenu: false,
      username: '',
      searchTerm: '',
      searchWO: '',
      orderTerm: 'scheduledDate',
      orderDesc: -1,
      loadingWorkOrders: true,
      sortOption01: true,
      sortOption02: false,
      sortOption03: false,
      sortOption04: false,
      sortOption05: false,
      mobileSortOpen: false,
      mobileSearchOpen: false,
      pickedMobileSort: "Date | Newest",
      workOrders: [
      ]
    }
  }
}
</script>

<style scoped>
.home-listing {
 padding-top: 102px;
  position: relative;
}

.mobileBottomBar {
  display: none;
}

  .home-listing .main-header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
    padding: 0;
  }

  .home-listing .main-header .top {
  background: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
  }

  .home-listing .header-btn {
    color: #fff;
    font-family: 'open_sanssemibold';
    font-size: 12px;
    margin-left: 10px;
  }

    .home-listing .header-btn i {
      margin-right: 5px;
    }

.loadingWorkOrders {
  text-align: center;
  font-size: 17px;
  font-family: 'open_sanssemibold';
  padding-top: 20px;
}

  .loadingWorkOrders img {
    display: block;
    margin: 0 auto 10px;
  }


  #woListing {
    width: 100%;
  }

  #woListing ul,
  #woListing ul li {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: block;
  width: 100%;
  }

    #woListing ul li {
      padding: 10px 0 10px 50px;
      background-image: url(../../static/img/icon-wo-open.png);
      background-repeat: no-repeat;
      background-position: 15px center;    
      cursor: pointer;
    }

    #woListing ul li.priorityHigh {
      border-left: 8px solid #cc0000;
    }

    #woListing ul li.priorityScheduled {
      border-left: 8px solid #66cc00;
    }

    #woListing ul li.priorityMedium {
      border-left: 8px solid #ff9900;
    }

    #woListing ul li .woTopRow {
      font-size: 16px;
    }

    #woListing ul li:nth-child(odd) {
      background-color: #eaeaea;
    }

     #woListing ul li strong {
     font-weight: normal;
     font-family: 'open_sansbold';
     }

      #woListing ul li img {
        padding-top: 30px;
      }

.tablet-view {
  background: #f5f8fb;
}

.flexrow {
  display: flex;
}

  .tablet-view .tabletSortSearchRow {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 12px; 
    font-family: 'open_sanssemibold';
  }

    .tablet-view .tabletSortSearchRow a {
      display: inline-block;
      margin: 0 0 5px;
      padding: 3px 10px;
      text-decoration: none;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
    }

    .tablet-view .tabletSortSearchRow a.active {
      color: #fff;
    }

    .tablet-view .tabletSortSearchRow .form-control {
      max-width: 70%;
      display: inline-block;
      margin-left: 10px;
      height: 26px;
      font-size: 12px;
      background-color: #e7edf2;
      border: 0;
    }

    .tablet-view .tabletSortSearchRow .btn {
      max-width: 10%;
      color: #fff;
    }

    .tablet-view .inner {
       background: #fff;
       min-height: 100%;
    }

    .tablet-view .inner-dark {
      background: #212121;
      color: #fff;
      padding: 5px;
      text-align: center;
      min-height: 100%;
    }

      .tablet-view .inner-dark h3 {
        border-top: #555 solid 2px;
        border-bottom: #555 solid 2px;
        padding: 10px 0;
        margin: 0;
        font-size: 16px;
        font-family: 'open_sanssemibold';
      }

      .tablet-view .inner-dark h3 span {
        font-size: 11px;
        text-transform: uppercase;
        color: #777;
        display: block;
        margin-bottom: 5px;
      }

      .tablet-view .inner-dark ul,
      .tablet-view .inner-dark ul li {
        margin: 0;
        padding: 0;
        list-style-type: none;
        text-align: right;
      }

       .tablet-view .inner-dark ul {
        padding-right: 20px;
        padding-top: 10px;
       }

        .tablet-view .inner-dark ul li {
          color: #fff;
          padding: 10px 0;
          cursor: pointer;
        }

        .tablet-view .inner-dark ul li i {
          margin-left: 5px;
          color: #999;
        }

    .tablet-view h2 {
      margin: 0;
      padding: 20px;
      font-size: 20px;
      border-bottom: 1px solid #ccc;
      font-family: "ralewayblack";
      text-transform: uppercase;
    }

    .tablet-view .completedtrue {
      border: 0 !important;
      background-image: none !important;
      padding: 10px 0 10px 10px !important;
    }

    .tablet-view .completedtrue:nth-child(odd) {
      background-color: #f3fbff !important;
    }

.mobile-view .completedtrue {
  background: #333 !important;
  color: #ccc;
  border-bottom: 1px dotted #666;
}
    .mobile-view .completedtrue .woTopRow {
      color: #fff;
    }


@media only screen and (max-width : 768px) {
  #woListing ul li img {
    padding-top: 40px;
  }

    #woListing ul li {
      font-size: 11px;
      background-position: 10px center;
      padding: 10px 0 10px 30px;
    }

    #woListing ul li .woTopRow {
      font-size: 13px;
    }

    #woListing ul li.completedtrue {
      background-image: url(../../static/img/icon-wo-closed.png) !important;
      background-color: #333 !important;
      background-repeat: no-repeat !important;
      background-position: 10px center !important;
      border-left: 8px solid #006600 !important;
    }

    #woListing ul li.priorityHigh {
      border-left: 8px solid #cc0000 !important;
    }

    #woListing ul li.priorityScheduled {
      border-left: 8px solid #66cc00 !important;
    }

    #woListing ul li.priorityMedium {
      border-left: 8px solid #ff9900 !important;
    }

  .mobileBottomBar {
    background: #fff url(../../static/img/mobileBottomBar_bg.png) center center repeat-y;
    height: 60px;
    position: fixed;
    bottom: 0px;
    display: block;
    z-index: 2;
    width: 100%;
    text-align: center;
    cursor: pointer;
    padding-top: 10px;
     -webkit-box-shadow: 0px -3px 5px #666;
    -moz-box-shadow:    0px -3px 5px #666;
    box-shadow:         0px -3px 5px #666;
    font-family: 'open_sanssemibold';
    font-size: 15px;
    color: #999;
  }

  .mobileBottomBar span {
    display: block;
    font-size: 12px;
  }

  .mobileBottomBar .searchDiv {
    padding-top: 10px;
  }

  .mobileBottomBar .searchDiv i {
    font-size: 17px;
    margin-right: 5px;
  }

  .mobile-sort {
    background: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    max-width: 75%;
    min-width: 50%;
    position: absolute;
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
    padding: 10px;
    text-align: center;
  }

    .mobile-sort h3 {
      font-family: 'open_sansbold';
      text-transform: uppercase;
      margin: 15px 0 15px 0;
      padding: 0;
      color: #000;
    }

    .mobile-sort p {
      display: block;
      margin: 0;
      border-bottom: 1px solid #ddd;
    }

    .mobile-sort p:last-of-type {
      border-bottom: 0px;
    }

    .mobile-sort p a {
    display: block;
    color: #333;
    text-decoration: none;
     padding: 10px 0;
    font-family: 'open_sanssemibold';
    }

    .mobile-sort p a.active {
      font-family: 'open_sansbold';
      text-transform: uppercase;
    }

  .mobile-search {
    background: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    width: 90%;
    position: absolute;
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
    padding: 10px;
    text-align: center;
    font-family: 'open_sansbold';
  }

    .mobile-search h3 {
      font-family: 'open_sansbold';
      text-transform: uppercase;
      margin: 15px 0 15px 0;
      padding: 0;
      color: #000;
    }

    .mobile-search input {
    margin-bottom: 20px;
    text-align: center;
    }

    .mobile-search a.btn {
      font-family: 'open_sansbold' !important;
      font-size: 16px;
      color: #fff;
      text-transform: uppercase;
    }

}

body {
min-height: 100%;
min-width: 100%;
}
 
.full-box {
  min-height: 100%;
  min-width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 5;
}

  .full-box .loadingWorkOrders {
    margin-top: 100px;
  }

  .full-box .main-logo {
    max-width: 150px;
  }

</style>



// WEBPACK FOOTER //
// Home.vue?6228edad